import { getWithAuth, putWithAuth } from 'services/http.service';
import { GET_RETURN_SETTINGS, UPDATE_RETURN_SETTINGS } from './url.service';

export const getReturnSettings = () => getWithAuth(GET_RETURN_SETTINGS);
export const updateReturnSettings = (settings) => putWithAuth(UPDATE_RETURN_SETTINGS, settings);
